import React, { useState } from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import Modal from "components/Modal";
import Translate from "helpers/Translate";

// styles
import "./Modal.css";

function UploadLog({ fileDoc }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <Modal isOpen={isOpen} width="40%" height="300px" padding="15px">
        <i
          className="far fa-times-circle pointer fr"
          onClick={() => {
            setIsOpen(false);
          }}
        ></i>

        {isEmpty(fileDoc?.adapter_props?.upload_errors) ? (
          <div className="my-30">
            {Translate({
              id: "no_logs_found_for",
              values: [fileDoc.raw_filename]
            })}
          </div>
        ) : null}

        {fileDoc?.adapter_props?.upload_errors?.length > 0 &&
          fileDoc.adapter_props.upload_errors.map((log, idx) => (
            <div key={idx} className="my-10">
              {log}
            </div>
          ))}
      </Modal>

      <button
        data-tip={Translate({ id: "show_error_logs" })}
        className="btn btn-default btn-sm center text-center"
        onClick={() => setIsOpen(true)}
      >
        <i className="far fa-file-alt fa-lg"></i>
      </button>
    </div>
  );
}

UploadLog.propTypes = {
  fileDoc: PropTypes.object
};

export default UploadLog;
